import React from "react";
import * as Lucide from "lucide-react";

/**
 * Resolve a lucide-react icon component by name.
 * Falls back to Circle if unknown.
 */
export default function Icon({ name, size = 20, className = "", strokeWidth = 1.5, ...rest }) {
  const Cmp = (name && Lucide[name]) || Lucide.Circle;
  return <Cmp size={size} strokeWidth={strokeWidth} className={className} {...rest} />;
}
